module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anthony C. Thiselton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("   "), _c('B', [_vm._v("Anthony C. Thiselton")]), _vm._v(" (1937–2023) was professor of Christian theology at the University of Nottingham, England. His many books include "), _c('I', [_vm._v("A Shorter Guide to the Holy Spirit, Systematic Theology")]), _vm._v(", and "), _c('I', [_vm._v("Life after Death: A New Approach to the Last Things.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6Ek6LG/tc-custom/9781467446266.jpg?1730409132662",
      "alt": "This image is the cover for the book A Shorter Guide to the Holy Spirit"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A Shorter Guide to the Holy Spirit\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Anthony Thiselton’s scholarly book "), _c('i', [_vm._v("The Holy Spirit — In Biblical Teaching, through the Centuries, and Today")]), _vm._v(" was published to wide acclaim in 2013 and received a 2014 "), _c('i', [_vm._v("Christianity Today")]), _vm._v(" Book Award. This shorter volume makes Thiselton’s vast biblical-theological knowledge and brilliant insight more accessible to more readers."), _c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0